import { useEffect } from "react";

/**
 * Pushes a sentinel state onto `history` when the modal/overlay opens, and
 * intercepts the browser/hardware back button so it closes the overlay
 * instead of leaving the page. Multiple instances can stack (modal → photo
 * lightbox) and each will pop in order. The sentinel state is cleaned up
 * automatically when the overlay closes via its own UI.
 */
export const useBackButtonClose = (isOpen, onClose, key = "overlay") => {
  useEffect(() => {
    if (!isOpen) return;
    const stateKey = `momenta_${key}`;
    window.history.pushState({ [stateKey]: true }, "");
    const onPop = () => onClose();
    window.addEventListener("popstate", onPop);
    return () => {
      window.removeEventListener("popstate", onPop);
      // If our sentinel is still on top of the stack (i.e., the overlay
      // was closed via its own button, not the back button), pop it so
      // the history doesn't accumulate stale entries.
      if (window.history.state && window.history.state[stateKey]) {
        window.history.back();
      }
    };
  }, [isOpen, onClose, key]);
};

export default useBackButtonClose;
